module.exports = {
      id: "google-play-usage",
      viewBox: "0 0 180 53.33",
      url: __webpack_public_path__ + "svg-sprite-a2aa2e5b3e3b70ea2fa34e79b698feaf.svg#google-play",
      toString: function () {
        return this.url;
      }
    }